import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-send-alert',
  templateUrl: './tutorial-send-alert.component.html',
  styleUrls: ['./tutorial-send-alert.component.css']
})
export class TutorialSendAlertComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
